<template>
  <!-- <v-row id="stuff" justify="center"> -->
  <v-menu
    attach="#chatInput"
    v-model="mainDialog"
    nudge-top="260px"
    max-width="100%"
    :close-on-content-click="false"
    origin="bottom right"
    tabindex="-1"
  >
    <v-card width="100vh" class="whiteScroll">
      <v-card-text class="pr-0 pl-1 pb-0" ref="mainCard">
        <div style="z-index:10; width:100%;">
          <v-form ref="addForm" @submit.prevent>
            <v-col cols="12" class="pt-0 mt-0 mb-0 pb-0">
              <v-text-field
                v-model="searchInput"
                autocomplete="off"
                placeholder="Search.."
                clearable
                append-icon="mdi-magnify"
                class="ma-0 pa-0"
              ></v-text-field>
            </v-col>
          </v-form>
          <v-divider class="ma-0 pa-0"></v-divider>
        </div>
        <div id="gifs" style="height:200px;overflow-y:scroll;">
          <div class="mt-3"></div>
          <div
            v-masonry="containerId"
            transition-duration="0.3s"
            item-selector=".item"
            gutter="15"
            fit-width="true"
            style="margin: 0 auto;"
          >
            <div
              v-masonry-tile
              class="item"
              v-for="(item, index) in gifs"
              :key="index"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card
                  add="1-3s"
                  color="black"
                  :elevation="hover ? 12 : 2"
                  style="cursor:pointer"
                  @click="select(item.real)"
                >
                  <v-progress-circular
                    indeterminate
                    color="white"
                    id="progress"
                  ></v-progress-circular>
                  <v-scale-transition origin="center center">
                    <v-btn
                      id="send"
                      color="black"
                      style="background-color:white"
                      v-show="hover"
                      icon
                    >
                      <v-icon>mdi-send</v-icon>
                    </v-btn>
                  </v-scale-transition>
                  <v-img
                    eager
                    max-width="100px"
                    max-height="100px"
                    add="1-3s"
                    :src="item.preview"
                  />
                </v-card>
              </v-hover>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
  <!-- <v-dialog v-model="mainDialog" @input="dismiss($event)" scrollable max-width="69%">
      <v-card height="65vh">
        <v-card-text class="pr-0 pl-1 pb-0" ref="mainCard">
          <div style="position:fixed; z-index:10; width:69%; left:15.5%;">
            <v-form ref="addForm" @submit.prevent>
              <v-col cols="12" class="pt-0 mt-0 mb-0 pb-0">
                <v-text-field
                  v-model="searchInput"
                  autocomplete="off"
                  placeholder="Search.."
                  clearable
                  prepend-icon="mdi-magnify"
                  class="mb-0 pb-0"
                ></v-text-field>
              </v-col>
            </v-form>
            <v-divider class="ma-0 pa-0"></v-divider>
          </div>
          <div style="height:calc(65vh - 70px);overflow-y:scroll; margin-top:70px; ">
            <div class="mt-4"></div>
            <div
              v-masonry="containerId"
              transition-duration="0.3s"
              item-selector=".item"
              gutter="15"
              fit-width="true"
              style="margin: 0 auto;"
            >
              <div v-masonry-tile class="item" v-for="(item, index) in gifs" :key="index">
                <v-hover v-slot:default="{ hover }">
                  <v-card add="1-3s" color="black" :elevation="hover ? 12 : 2" style="cursor:pointer">
                    <v-progress-circular indeterminate color="white" id="progress"></v-progress-circular>
                    <v-scale-transition origin="center center"><v-btn id="send" color="black" style="background-color:white" v-show="hover" icon><v-icon>mdi-send</v-icon></v-btn></v-scale-transition>
                    <v-img
                      eager
                      max-width="210px"
                      max-height="200px"
                      add="1-3s"
                      :src="hover ? item.real : item.preview"
                    />
                  </v-card>
                </v-hover>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
  </v-dialog>-->
  <!-- </v-row> -->
</template>

<style scoped>
::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
}

::-webkit-scrollbar-track {
  background: rgb(230, 230, 230) !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(170, 170, 170) !important;
}

#progress {
  position: absolute;
  top: calc(50% - 16px);
  left: calc(50% - 16px);
}

#send {
  z-index: 100;
  position: absolute;
  top: calc(50% - 18px);
  left: calc(50% - 18px);
}

.item {
  margin-bottom: 15px;
}
</style>

<script>
export default {
  props: ["user"],
  data: () => ({
    apiKey: "YR7ARK2XODB0",
    mainDialog: false,
    resolve: null,
    gifs: [],
    containerId: 0,
    searchInput: "",
    next: 0,
    oldNext: 0,
    oldSearchInput: "",
    ready: false
  }),
  created() {
    this.getResults("surprised", 0, 8);

    setTimeout(() => {
      this.ready = true;
    }, 3000);

    setInterval(() => {
      this.$redrawVueMasonry();

      if (this.mainDialog) {
        let current = document.getElementById("gifs").scrollTop;
        let top = document.getElementById("gifs").scrollHeight - 200;
        if (
          current == top &&
          this.gifs.length &&
          this.oldNext !== this.next &&
          this.ready
        ) {
          this.oldNext = this.next;
          this.getResults(this.searchInput, this.next, 6);
        }
      }
    }, 100);
  },
  methods: {
    open() {
      this.ready = false;

      setTimeout(() => {
        this.ready = true;
      }, 3000);

      this.oldNext == null;
      this.gifs = [];
      this.getResults("surprised", 0, 8);
      this.mainDialog = true;
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },
    select(gif) {
      this.mainDialog = false;
      this.resolve(gif);
    },
    httpGetAsync(theUrl, callback) {
      let xmlHttp = new XMLHttpRequest();

      xmlHttp.onreadystatechange = function() {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
          callback(xmlHttp.responseText);
        }
      };

      xmlHttp.open("GET", theUrl, true);

      xmlHttp.send(null);
    },
    getResults(search, pos, limit) {
      let search_url =
        "https://api.tenor.com/v1/search?q=" +
        search +
        "&key=" +
        this.apiKey +
        "&limit=" +
        limit +
        "&pos=" +
        pos;

      this.httpGetAsync(search_url, responsetext => {
        let response = JSON.parse(responsetext);
        console.log(response); //eslint-disable-line
        this.next = response.next;
        for (let i = 0; i < response.results.length; i++) {
          let m = response.results[i];
          this.gifs.push({
            preview: m.media[0].tinygif.url,
            real: m.media[0].gif.url
          });
        }
      });
    }
  },
  watch: {
    searchInput: function() {
      this.oldNext == null;
      this.gifs = [];
      this.getResults(this.searchInput, 0, 8);
    }
  }
};
</script>
